<template>
    <div style="padding-left: 5%;width:90%">
      <mds-loader size="large" aria-label="Large Loader" v-if=showLoader></mds-loader>
        <mds-table>
    <mds-thead>
        <mds-th> User Id </mds-th>
        <mds-th> Department Id </mds-th>
        <mds-th> Name </mds-th>
        <mds-th> Email </mds-th>
        <mds-th> Designation </mds-th>
        <mds-th> IsActive </mds-th>
        <mds-th> IsAdmin </mds-th>
    </mds-thead>
    <mds-tbody>
        <mds-tr v-for="user in userList" :key="user.userid">
            <mds-td> {{ user.userId }} </mds-td>
            <mds-td> {{ user.departmentId }} </mds-td>
            <mds-td> {{ user.name }} </mds-td>
            <mds-td> {{ user.emailId }} </mds-td>
            <mds-td> {{ user.userDesignation }} </mds-td>
            <mds-td> {{ user.isActive }} </mds-td>
            <mds-td> {{ user.isAdmin }} </mds-td>
        </mds-tr>
    </mds-tbody>
</mds-table>
<mds-pagination show-items-info show-items-select :total-items="100"></mds-pagination>
    </div>
  </template>
  
  <script>
  import axiosInstance from "@/AxiosTokenInstance";
  import {
    MdsTable,
    MdsThead,
    MdsTh,
    MdsTbody,
    MdsTr,
    MdsTd,
  } from "@mds/data-table-vue3";
  import MdsLoader from "@mds/loader-vue3";
  import MdsPagination from '@mds/pagination-vue3';
  import { MdsButton } from "@mds/button-vue3";
  import MdsSelect from '@mds/select-vue3'
  import MdsModal from '@mds/modal-vue3'
  import { mapState,mapActions,mapMutations } from 'vuex'
  import config from '../../config'
  export default {
    name: "UserList",
    components: {
      MdsTable,
      MdsThead,
      MdsTh,
      MdsTbody,
      MdsTr,
      MdsTd,
      MdsLoader,
      MdsPagination,
      MdsButton,
      MdsSelect,
      MdsModal,
    },
    data(){
      return {
        userList :[],
        showLoader : false,
        toggle:false,
      }
    },
    mounted(){
    this.getUsers();
  },
  methods:{
  getUsers() {
    this.showLoader = true;
    axiosInstance.get(config.api_url+"User/Users")
    .then(response=>{
      this.userList=response.data.data;
      this.showLoader = false;
      })
    .catch(error=>{
      console.log(error.response)
      this.showLoader = false;
    })
 
  },
   redirect ()  {
  window.open("https:google.com",'_blank')
}
},
computed:{
   ...mapState('auth',{
    userDetails:state=>state.userDetails,
   })
  }
    
  };
  </script>
  
                                                              